import { useContext } from 'react';
import { Typography, Box, Unstable_Grid2 as Grid } from '@mui/material';
import { useFormState, useField } from 'react-final-form';

import { LinearProgress, Card, CardContent, CardHeader } from '@occc/ui-design-system';
import { Map } from '@occc-app/design-system';

import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';
import { LocationContext } from './LocationProvider';
import { LocationUpdateFormData } from './types';

import LocationDetailsFormContent from '../components/LocationDetailsFormContent';
import LocationAddressFormContent from '../components/LocationAddressFormContent';
import LocationAttributesFormContent from '../components/LocationAttributesFormContent';
import LocationPluginFormContent from '../components/LocationPluginFormContent';
import LocationLoyaltyDetailsFormContent from '../components/LocationLoyaltyDetailsFormContent';
import { LocationGroupMultiSelect } from '../components/LocationGroupMultiSelect';

export const LocationGeneralDetailsEdit = () => {
  const state = useFormState<LocationUpdateFormData>();
  const coordinatesField = useField('address.geoLocation');

  const onMarkerDrag = (event: google.maps.MapMouseEvent) => {
    coordinatesField.input.onChange({
      latitude: event.latLng?.lat() || 0,
      longitude: event.latLng?.lng() || 0,
    });
  };

  const geoLocation = state.values?.address?.geoLocation;

  const isUserPermittedToAddLocationToGroup = useIsUserPermittedTo(Feature.LOCATION_ADD_TO_GROUP);

  const { loading } = useContext(LocationContext);
  return (
    <div>
      <Box mb={1}>
        <Card>
          {loading && <LinearProgress />}
          <CardContent>
            <Grid container columnSpacing={3} rowSpacing={2}>
              <Grid xs={12} sm={3}>
                <LocationDetailsFormContent />
              </Grid>
              <Grid xs={12} sm={3}>
                <LocationPluginFormContent />
              </Grid>
              {isUserPermittedToAddLocationToGroup && (
                <Grid xs={12} sm={6}>
                  <LocationGroupMultiSelect />
                </Grid>
              )}
              <Grid md={12}>
                <LocationLoyaltyDetailsFormContent />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>

      <Box mb={1}>
        <Card>
          {loading && <LinearProgress />}
          <CardHeader title={<Typography variant='h6'>Address</Typography>} />
          <CardContent>
            <LocationAddressFormContent />
          </CardContent>
        </Card>
      </Box>

      <Map
        isEditable
        latitude={geoLocation?.latitude}
        longitude={geoLocation?.longitude}
        onMarkerDragEnd={onMarkerDrag}
      />

      <Card sx={{ mt: 1 }}>
        {loading && <LinearProgress />}
        <CardHeader title={<Typography variant='h6'>Attributes</Typography>} />
        <CardContent>
          <LocationAttributesFormContent />
        </CardContent>
      </Card>
    </div>
  );
};
